import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Package } from 'lucide-react';
import { formatINR } from '../../../utils/format';

/** Product image, or a neutral tile when there is none or it fails to load. */
export const ProductThumb = ({ src, size = 'md' }) => {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return (
      <span className={`pk-thumb pk-thumb--${size} pk-thumb--empty`} aria-hidden="true">
        <Package />
      </span>
    );
  }
  return (
    <img
      className={`pk-thumb pk-thumb--${size}`}
      src={src}
      alt=""
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
};

const itemPrice = item => {
  if (Number.isFinite(Number(item.totalPrice))) return item.totalPrice;
  return Number(item.unitPrice || 0) * (item.quantity || 1);
};

const OrderItemsList = ({ items }) => {
  if (!items?.length) return null;

  return (
    <section className="pk-card" aria-labelledby="order-items-title">
      <div className="pk-card__head">
        <h2 className="pk-card__title" id="order-items-title">
          {items.length === 1 ? 'Project' : `Projects (${items.length})`}
        </h2>
      </div>
      <ul className="pk-order-items">
        {items.map((item, index) => (
          <li key={`${item.productId}-${index}`} className="pk-order-item">
            <ProductThumb src={item.productImage} />
            <div className="pk-order-item__body">
              {item.productId ? (
                <Link to={`/products/${item.productId}`} className="pk-order-item__name">
                  {item.productName}
                </Link>
              ) : (
                <span className="pk-order-item__name">{item.productName}</span>
              )}
              {item.productDescription && <p className="pk-order-item__desc">{item.productDescription}</p>}
              {item.quantity > 1 && <span className="pk-order-item__meta">Quantity {item.quantity}</span>}
            </div>
            <span className="pk-order-item__price">{formatINR(itemPrice(item))}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default React.memo(OrderItemsList);
